export enum GameThemeType {
  Light = 1,
  Dark = 2,
}
